import BoardService from '../services/board.service';
import moment from 'moment';

export const updateWsGraphData = (tagId: string) => {
  const $wrapper = $('.ws-graph-top-view-wrapper');
  const $spinner = $('.workstreamLoader.loading');

  $spinner.show();

  // backend recalculating workstream stats asynchronously, so there is no guarantee when the data will be available
  setTimeout(async () => {
    const service = new BoardService();

    const response = await service.getWsGraphData({ id: tagId });

    const data = response.data;

    if (!data) {
      $spinner.hide();

      return;
    }

    if (data.progress) {
      $wrapper.find('.midRowMin .wsTopHeadCompletion').html(data.progress + '%');
      $wrapper.find('.midRowMin .completetionChartValue .chartValue').css('width', data.progress + '%');
    }

    if (data.dataMisc) {
      $wrapper.find('.midRowMin .riskCountVal').html(data.dataMisc.red);
      $wrapper.find('.midRowMin .lateCountVal').html(data.dataMisc.late);
      $wrapper.find('.midRowMin .doingCountVal').html(data.dataMisc.doing);
    }

    $spinner.hide();
  }, 6000); // 6 seconds is lowest which constantly works
};

export const constructAiAutomationData = (data: any) => {
  let aiData: any = {};
  const {
    owner,
    owner_firstname,
    owner_lastname,
    owner_email,
    ownerImage,
    due_date,
    clearDate,
    dueDateText,
    dueDateTextFormatted,
    updateSameExtendDays,
    extendDays,
    type_0,
    type_1,
    type_2,
    state,
    rag,
    priority,
    effort,
  }: any = data;

  if (owner && owner.length > 0) {
    aiData.owner = owner;
    aiData.owner_firstname = owner_firstname;
    aiData.owner_lastname = owner_lastname;
    aiData.owner_email = owner_email;
    aiData.ownerImage = ownerImage;
  }

  if (due_date && due_date != '') {
    aiData.due_date = due_date;
    aiData.dueDateTextFormatted = dueDateTextFormatted;
    aiData.dueDateText = dueDateText;
  }
  if (typeof updateSameExtendDays !== 'undefined' && updateSameExtendDays != null) {
    if (!updateSameExtendDays && parseInt(extendDays) > 0) {
      aiData.extendDays = parseInt(extendDays);
    }
  }
  if (clearDate) {
    aiData.clearDate = clearDate;
  }
  if (state) {
    aiData.state = state;
  }
  if (rag) {
    aiData.rag = rag;
  }
  if (priority) {
    aiData.priority = priority;
  }
  if (effort) {
    aiData.effort = effort;
  }
  if (type_0) {
    aiData.type_0 = type_0;
  }
  if (type_1) {
    aiData.type_1 = type_1;
  }
  if (type_2) {
    aiData.type_2 = type_2;
  }
  return aiData;
};

export const mergeAiAutomationData = (ai: any, automationData: any) => {
  let { extendDays, clearDate } = automationData;
  const { due_date } = ai;
  let newData: any = automationData;
  if (typeof clearDate !== undefined && clearDate) {
    newData.due_date = 0;
    newData.dueDateText = 'No Date';
    newData.dueDateTextFormatted = 'No Date';
    newData.start_date = 0;
    newData.startDateText = 'No Date';
    newData.startDateTextFormatted = 'No Date';
  } else {
    if (extendDays && extendDays != null) {
      extendDays = parseInt(extendDays);
      if (typeof due_date !== 'undefined' && parseInt(due_date) > 0 && extendDays > 0) {
        const new_date = moment(parseInt(due_date) * 1000).add(extendDays, 'days');
        const new_date_value: any = new_date.valueOf();
        if (new_date_value > 0) {
          newData.due_date = new_date_value / 1000;
          const displayDateText: string = moment(new_date_value).format('MMM DD, YYYY');
          newData.dueDateText = displayDateText;
          newData.dueDateTextFormatted = displayDateText;
        }
      }
    }
  }
  return { ...ai, ...newData };
};

export const constructWsAutomationData = (data: any) => {
  let wsData: any = {};
  const {
    owner,
    owner_firstname,
    owner_lastname,
    owner_email,
    ownerImage,
    status,
    pace,
    health,
    priority,
    start_date,
    target_date,
  } = data;
  if (owner && owner.length > 0) {
    wsData.owner = owner;
    wsData.owner_firstname = owner_firstname;
    wsData.owner_lastname = owner_lastname;
    wsData.owner_email = owner_email;
    wsData.owner_picture = ownerImage;
  }
  if (status && status.length > 0) {
    wsData.status = status;
  }
  if (pace && pace.length > 0) {
    wsData.pace = pace;
  }
  if (health && health.length > 0) {
    wsData.health = health;
  }
  if (priority && priority.length > 0) {
    wsData.priority = priority;
  }
  if (start_date && start_date != '') {
    wsData.start_date = start_date;
  }
  if (target_date && target_date != '') {
    wsData.target_date = target_date;
  }
  return wsData;
};

export const constructUserAutomationData = (data: any) => {
  const userData: any = {};
  const { user_availabilty_date, leave_user } = data;
  if (user_availabilty_date && user_availabilty_date != '') {
    userData.user_availabilty_date = user_availabilty_date;
  }
  if (leave_user && leave_user == '1') {
    userData.leave_user = 1;
  }
  return userData;
};

export const mergeUserAutomationData = (user: any, data: any) => {
  let newData: any = {};
  const { user_availability_date } = data;
  if (user_availability_date && typeof user_availability_date[user.id] !== undefined) {
    newData.user_availability_date = user_availability_date[user.id];
  }
  return { ...user, ...newData };
};
